/**
 * Flow Optimizer — sub-formula weight normalizer.
 * Sub-formulas within a blocks group SHARE 100%. This normalizes their raw
 * weights to integers summing to exactly 100, reusing the same largest-remainder
 * logic as group weights. Missing/all-zero weights fall back to an equal split,
 * which scales every item by the same constant → outcome-neutral vs. legacy
 * configs (group scores are re-normalized per layer downstream).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FormulaSubformula } from "../voluum-flow-optimizer.types";
import { normalizeWeightsToHundred } from "./normalize-weights";

export function normalizeSubformulaWeights(
  subs: ReadonlyArray<Pick<FormulaSubformula, "id" | "weight">>,
): Record<string, number> {
  const ids = subs.map((s) => s.id);
  const byId: Record<string, number> = {};
  for (const s of subs) {
    byId[s.id] = typeof s.weight === "number" ? s.weight : 0;
  }
  return normalizeWeightsToHundred(byId, ids);
}
